export const setSponsoredProductRanks = (products, lowerOffset) =>
  products.map((product, index) => ({
    ...product,
    sponsoredRank: product.sponsoredCampaignId ? lowerOffset + index + 1 : null
  }));

export default setSponsoredProductRanks;
